export const valueFormatting = (value, pretty) => {
  if (value === '£') return '';
  let val = value.replace(/\D/g,'');
  if (val === '') return '';
  val = parseInt(val);
  if (pretty) val = '£' + val.toLocaleString('en-gb');
  return val;
};
